export default __webpack_public_path__ + "static/media/logo.e39b5349.png";